import styled from 'styled-components'
import { RiDeleteBin6Line } from 'react-icons/ri'
import { Button } from '@outbound-ai/ursa'
import { DISCARD_BUTTON, IGNORE_BUTTON } from './Constants'

interface IProps {
  selectBtn: (value: string) => void
}

export const ClaimProcessDiscard = ({ selectBtn }: IProps) => {
  return (
    <Div>
      <div className="delete-icon-container">
        <RiDeleteBin6Line className="delete-icon" />
      </div>
      <div className="content">
        <h3>Are you sure you want to cancel this upload and its validation results?</h3>
        {/* <p>This action cannot be undone.</p> */}
      </div>
      <div className="footer-container">
        <Button
          radius="rounded"
          className="discard-btn"
          variant="danger-outline"
          size="large"
          onClick={() => selectBtn(DISCARD_BUTTON)}
        >
          Yes, cancel this upload
        </Button>
        <Button radius="rounded" variant="primary" size="large" onClick={() => selectBtn(IGNORE_BUTTON)}>
          No, keep going
        </Button>
      </div>
    </Div>
  )
}

const Div = styled.div`
  position: absolute;
  top: 6.25rem;
  left: 0;
  right: 0;
  bottom: 0;
  margin: 0 1.5rem;
  padding: 2rem 0;
  padding-top: 9.25rem;
  text-align: center;
  z-index: 999;
  background: ${({ theme }) => theme.colors.neutral.lightest};
  .delete-icon {
    width: 3.5rem;
    height: 3.5rem;
    color: ${({ theme }) => theme.colors.error.neutral};
  }
  .content {
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
    letter-spacing: normal;
    width: 24rem;
    margin: 1rem auto;
    h3 {
      font-size: 1.125rem;
      font-weight: 600;

      color: ${({ theme }) => theme.colors.neutral.neutral};
    }
    p {
      margin-top: 0.5rem;
      font-size: 1rem;
      font-stretch: normal;
      font-style: normal;
      color: ${({ theme }) => theme.colors.grey.dark};
    }
  }
  .footer-container {
    margin-top: 5rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    button {
      width: 100%;
    }
    .discard-btn {
      margin-right: 1rem;
    }
  }
`
